import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M7 3H4C3.45 3 3 3.45 3 4V20C3 20.55 3.45 21 4 21H7C7.55 21 8 20.55 8 20V4C8 3.45 7.55 3 7 3ZM7 20H4V19H5V18H4V17H5V16H4V15H5V14H4V13H5V12H4V11H5V10H4V9H5V8H4V7H5V6H4V4H7V20Z"
      fill="currentColor"
    />
    <path
      d="M20.87 19.5L11.86 3.49005C11.63 3.10005 11.18 2.92005 10.74 3.04005C10.3 3.16005 10 3.54005 10 4.00005V20C10 20.55 10.45 21 11 21H20C20.36 21 20.69 20.81 20.87 20.5C21.05 20.18 21.04 19.81 20.87 19.5ZM11 20V19.0001H12V18.0001H11V17.0001H12V16.0001H11V15.0001H12V14.0001H11V13.0001H12V12.0001H11V11.0001H12V10.0001H11V9.00005H12V8.00005H11V7.00005H12V6.00005H11V3.99005L20 20H11Z"
      fill="currentColor"
    />
    <path d="M13 10V19H18L13 10ZM14 13.859L16.3 18H14V13.859Z" fill="currentColor" />
  </>
);

const Icon = createSvgIcon(svg, 'Rulers');

export default Icon;
